<script>
export default {
  props: {
    disabled: Boolean,
    buttonArray: Array,
    rowData: Object
  },
  computed: {
    btnClass() {
      if (this.disabled) {
        return "disabled";
      }
    }
  },
  methods: {
    click(key) {
      // console.log("row:", key);
      // if (this.info.action) {
      this.$emit("onOperationClick", this.rowData, key);
      // }
    }
  }
};
</script>

<template>
  <span class="textButton">
    <el-button
      v-for="item in buttonArray"
      :key="item.key"
      :disabled="item.disabled"
      type="text"
      size="small"
      @click.stop="click(item.key)"
    >{{item.text}}</el-button>
  </span>
</template>

<style lang="scss" scoped>
@import "./css/color.scss";
@import "./css/common.scss";

.textButton {
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .el-button--text {
    color: $mainPurple;
  }

  .el-button--small {
    font-size: 14px;
  }

  .el-button + .el-button {
    margin-left: 10px;
    border-left-color: #e4e8eb;
    border-left-width: 1px;
    padding-left: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.line {
  width: 1px;
  background-color: #e4e8eb;
  height: 20px;
  margin: auto 5px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/textButtonGroup.vue